export default "__VITE_ASSET__Cut_gOcT__"